(function () {
  const dataEl = document.querySelector('[id^="VariantMCMData-"]');
  if (!dataEl) return;

  const sectionId = dataEl.id.replace('VariantMCMData-', '');
  const atcBtn = document.getElementById(`AddToCart-${sectionId}`);
  const leadEl = document.getElementById(`MCMLeadtime-${sectionId}`);

  if (!atcBtn) return;

  const data = JSON.parse(dataEl.textContent || '{}');
  const map = new Map((data.variants || []).map(v => [String(v.id), !!v.pickup_at_mcm]));

  const labelSpan = atcBtn.querySelector('span');
  const defaultLabel = atcBtn.dataset.defaultLabel || 'Add to cart';

  const setState = (variantId) => {
    const pickupAtMCM = map.get(String(variantId));

    if (pickupAtMCM) {
      if (labelSpan) labelSpan.textContent = defaultLabel;
      if (leadEl) leadEl.hidden = true;
    } else {
      if (labelSpan) labelSpan.textContent = 'Made to order — ships in 8–10 weeks';
      if (leadEl) leadEl.hidden = false;
    }

    // Always keep enabled (your preference)
    atcBtn.disabled = false;
  };

  // Dawn updates the hidden variant id input
  const variantInput = document.querySelector(`form[action*="/cart/add"] input[name="id"]`);
  if (!variantInput) return;

  // Initial render
  setState(variantInput.value);

  // React to variant changes
  variantInput.addEventListener('change', (e) => setState(e.target.value));
})();
